import React from 'react';

export function CustomCodeWrapper() {
    return <></>;
}
